// extracted by mini-css-extract-plugin
export var box = "_65-0";
export var check = "_65-1";
export var checkboxButton = "_65-6";
export var checkboxGroup = "_65-5";
export var disabled = "_65-7";
export var ghost = "_65-9";
export var input = "_65-2";
export var label = "_65-4";
export var normal = "_65-8";
export var uncheck = "_65-3";